import { Poly } from "../../../engine/Poly";
import { CoreLoaderTexture } from "../Texture";
import { BaseTextureLoader } from "./_BaseTextureLoader";
export class BaseImageLoader {
}
export class BaseCoreImageLoader extends BaseTextureLoader {
  constructor(_url, _node) {
    super(_url, _node);
    this._node = _node;
  }
  async loadImage(options) {
    const url = await this._urlToLoad();
    return new Promise(async (resolve, reject) => {
      const loader = await this._getLoader(options);
      CoreLoaderTexture.incrementInProgressLoadsCount();
      await CoreLoaderTexture.waitForMaxConcurrentLoadsQueueFreed();
      loader.load(url, (texture) => {
        CoreLoaderTexture.decrementInProgressLoadsCount();
        texture.matrixAutoUpdate = false;
        const callback = CoreLoaderTexture._onTextureLoadedCallback;
        if (callback) {
          callback(url, texture);
        }
        resolve(texture);
      }, void 0, (error) => {
        CoreLoaderTexture.decrementInProgressLoadsCount();
        Poly.warn("error", error);
        reject();
      });
    });
  }
}
